export const BookButtonWebHeight = "h-[52px]";
export const PaddingForBookButtonWeb = "pb-[52px]";

export const DayOptions = [
  { label: "星期一", value: "MON" },
  { label: "星期二", value: "TUE" },
  { label: "星期三", value: "WED" },
  { label: "星期四", value: "THU" },
  { label: "星期五", value: "FRI" },
  { label: "星期六", value: "SAT" },
  { label: "星期日", value: "SUN" },
  { label: "公眾假期", value: "PUBLIC-HOLIDAY" },
];
